import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  mianDiv: { width: '70%', [theme.breakpoints.down('sm')]: { width: '100%' } },
  title: { marginBottom: '5%' },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  button: {
    width: 135,
    height: 33,
    [theme.breakpoints.down('sm')]: { width: '100%', marginTop: 12 }
  },
  passwordIconContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  form: { width: '70%', [theme.breakpoints.down('sm')]: { width: '100%' } },
  circularProgress: {
    marginLeft: 8,
    color: theme.palette.primary.main
  }
}))
